<template>
  <v-container class="pa-0">
    <div class="line-bc">
      <div class="balloon6">
        <div class="faceicon">
          <img :src="iconUrl" />
        </div>
        <div class="chatting">
          <div class="says-border">
            <span v-html="bubbleContentHtml" />
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "OrderConfirmBubble",
  components: {},
  props: {
    order: Object,
  },

  data: () => ({
    bubbleContentHtml: "",
  }),
  created() {},
  mounted() {
    this.initBubbleContent(this.order);
  },
  computed: {
    ...mapGetters(["progress", "iconUrl"]),
  },
  methods: {
    ...mapActions(["showProgress", "hideProgress"]),
    initBubbleContent: function (order) {
      const text = `こちらの内容でよろしいですか？`;
      let content1 = "";
      if (order.visitTime) {
        const visitTimeHHMM = this.$options.filters.momentJS(
          order.visitTime,
          "HH:mm"
        );
        content1 = `<span class="text-body-2">受取時間</span><span class="ml-4 text-h6">${visitTimeHHMM}</span>`;
      }

      let content = `${text}`;
      if (content1) {
        content = `${text}<br/>${content1}`;
      }

      this.bubbleContentHtml = content;
    },
  },
};
</script>

<style>
@import "../../css/bubble.css";
</style>
